import React, { memo, useState } from "react";
import ProductFilterInside from "./ProductFilterInside";

const ProductFilters = memo(() => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  return (
    <div className="filters-wrapper">
      <div className="category-filter">
        <div className="items">
          <div className="item">
            <div className="wrapper">
              <h2>מותג</h2>
              <div className="wrap">
                <ProductFilterInside
                  parameterName={"subBrand"}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="wrapper">
              <h2>כשרות</h2>
              <div className="wrap">
                <ProductFilterInside
                  parameterName={"kosherSupervision[0].supervisionAgency"}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="wrapper">
              <h2>בשרי / חלבי</h2>
              <div className="wrap">
                <ProductFilterInside
                  parameterName={"kosherSupervision[0].classification"}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProductFilters;
